import React from 'react';
import { Navigate } from 'react-router-dom';
import { isFinanceAuthenticated } from '../lib/auth';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  if (!isFinanceAuthenticated()) {
    return <Navigate to="/finance" replace />;
  }

  return <>{children}</>;
}